




import Vue from 'vue';
import Component from 'vue-class-component';
import { db } from '@/plugins/firebase';
import { Project } from '@/types';
import { Entry } from '@/types';
import { getModule } from 'vuex-module-decorators';
import Transcription from '@/store/modules/transcription';
import store from '@/store/store';
import { Watch } from 'vue-property-decorator';
import * as Koji from 'koji-lang';
import {
  ANTLRInputStream,
  CommonTokenStream,
  ANTLRErrorListener,
  Recognizer,
  RecognitionException,
} from 'antlr4ts';
const trscModule = getModule(Transcription, store);

@Component
export default class TrscView extends Vue {
  get text() {
    if (!trscModule.currentTranscription) return '';
    if (trscModule.isCurrentUserEditing || trscModule.isSyncMode) {
      return trscModule.currentTranscription.tempText;
    } else {
      return trscModule.currentTranscription.text;
    }
  }

  get html() {
    const result = Koji.parse(this.text);
    return Koji.convertToHTML(result.ast);
  }

  /*  @Watch('$route')
  onRouteChange() {
    console.log('route change');
    this.setHtml();
  }
  */
  @Watch('html')
  onTextChange() {
    this.$nextTick(() => { (window as any).tippy('[data-annotation-coment]', { content: (el: Element) => el.innerHTML.replace(/\//g, '<br>'), placement: 'right' }); });
  }
}
